import { useEffect, useState } from 'react';
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FaEye, FaRegEyeSlash } from 'react-icons/fa';
import { passwordValidationRules } from '../../utils/validationSchema'; 
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/slices/auth/authSlice';
import { updatePassword } from '../../store/slices/userManagment/userManagementThunk';

const EMPTY_VALUES = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
};

export function ChangePassword({ show, handleClosePopup }) {
  const [showCurrent, setShowCurrent] = useState(false);
const [showNew, setShowNew] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: EMPTY_VALUES
  });
  
  /**
   * FIX: Reset form and clear errors when Modal closes or opens
   */
  /**
   * Manage form state based on Modal visibility and Edit/Add mode
   */
  useEffect(() => {
    if (show) {
      // MODAL OPENING: Load data if in edit mode, otherwise start fresh
    //   if (currentActiveUser) {
    //     reset({
    //       ...currentActiveUser,
    //       // Ensure status is mapped correctly to your Select options if needed
    //       isActive: currentActiveUser.isActive ? 'Active' : 'Inactive',
    //       password: '',
    //       locationId: currentActiveUser.locationId
    //     });
    //   } else {
    //     reset(EMPTY_VALUES);
    //   }
    } else {
      // MODAL CLOSING: Fully clear the form and state
      reset(EMPTY_VALUES);
      setShowPassword(false);
    }
  }, [show  , reset]);

  /// Handling form
  const onSubmit = async (data) => {
    const body = {
      ...data
    };

    try {
    // 1. Dispatch the update thunk and "unwrap" the promise
    await dispatch(updatePassword({oldPassword: body.currentPassword, newPassword: body.newPassword})).unwrap();

    // 2. Show a success toast/alert (Optional but recommended)
    // toast.success("Password updated! Please log in again.");

    // 3. Manually dispatch the logout action to clear the state
    dispatch(logout());

    // 4. Clean up side effects
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');

  } catch (error) {
    // This catches the 'rejected' case from your thunk
    console.error("Failed to update password:", error);
  }
    
    // handleClosePopup();
    // reset(EMPTY_VALUES);
  };

  return (
// 1. Suggestion: Use separate states for visibility if you want independent toggles


// ... inside your component

<Modal show={show} onHide={handleClosePopup} centered size="md" backdrop="static">
  <Modal.Header closeButton className="border-0">
    <Modal.Title style={{ fontWeight: "600" }}>
      {t('common.enterYourNewPassword')}
    </Modal.Title>
  </Modal.Header>
  <hr className="m-0" />
  <Modal.Body>
    <Form autoComplete='off' onSubmit={handleSubmit(onSubmit)}>
      
      {/* CURRENT PASSWORD */}
      <Form.Group className="mb-3">
        <Form.Label className="small fw-bold text-muted text-uppercase">
          {t('common.currentPassword')} <span className="text-danger">*</span>
        </Form.Label>
        <InputGroup hasValidation>
          <Form.Control
            type={showCurrent ? 'text' : 'password'}
            isInvalid={!!errors.currentPassword} // FIXED: Changed from errors.password
            className="py-2"
            placeholder={t('placeholderText.currentPassword')}
            {...register('currentPassword', passwordValidationRules(t, false))}
          />
          <Button variant="outline-secondary" onClick={() => setShowCurrent(!showCurrent)}>
            {showCurrent ? <FaEye /> : <FaRegEyeSlash />}
          </Button>
          <Form.Control.Feedback type="invalid">
            {errors.currentPassword?.message}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      {/* NEW PASSWORD */}
      <Form.Group className="mb-3">
        <Form.Label className="small fw-bold text-muted text-uppercase">
          {t('common.newPassword')} <span className="text-danger">*</span>
        </Form.Label>
        <InputGroup hasValidation>
          <Form.Control
            type={showNew ? 'text' : 'password'}
            isInvalid={!!errors.newPassword} // FIXED: Changed from errors.password
            className="py-2"
            placeholder={t('placeholderText.newPassword')}
            {...register('newPassword', passwordValidationRules(t, false))}
          />
          <Button variant="outline-secondary" onClick={() => setShowNew(!showNew)}>
            {showNew ? <FaEye /> : <FaRegEyeSlash />}
          </Button>
          <Form.Control.Feedback type="invalid">
            {errors.newPassword?.message}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      {/* CONFIRM PASSWORD */}
      <Form.Group className="mb-3">
        <Form.Label className="small fw-bold text-muted text-uppercase">
          {t('common.confirmPassword')} <span className="text-danger">*</span>
        </Form.Label>
        <InputGroup hasValidation>
          <Form.Control
            type={showNew ? 'text' : 'password'} // Usually matches New Password visibility
            isInvalid={!!errors.confirmPassword} // FIXED: Changed from errors.password
            className="py-2"
            placeholder={t('placeholderText.confirmPassword')}
            {...register('confirmPassword', {
              required: t('validation.confirmPasswordRequired'),
              validate: (value) => value === watch('newPassword') || t('validation.passwordsDoNotMatch')
            })}
          />
          <Form.Control.Feedback type="invalid">
            {errors.confirmPassword?.message}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </Form>
  </Modal.Body>

  <Modal.Footer className="border-0">
    <Button variant="link" className="text-muted text-decoration-none" onClick={handleClosePopup}>
      Cancel
    </Button>
    <Button variant="dark" className="px-4 py-2 shadow-sm" onClick={handleSubmit(onSubmit)}>
      Update Password
    </Button>
  </Modal.Footer>
</Modal>
  );
}
